import { object, string } from 'yup';
import { CreateCommand } from '../../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../../enums.js';

const SCHEMA = object({
  id: string().required(),
});

/**
 * MySpaceMySolicitationsCreateEvent
 *
 * - Evento emitido quando uma solicitação é criada e deve ser adicionada ao meu espaço.
 */
export class MySpaceMySolicitationsCreateEvent extends CreateCommand(
  RealtimeEventType.MySpaceMySolicitationsCreate,
  SCHEMA,
) {}
